import { render, staticRenderFns } from "./Asistentesxpuestos.vue?vue&type=template&id=5642b0e5&scoped=true"
import script from "./Asistentesxpuestos.vue?vue&type=script&lang=js"
export * from "./Asistentesxpuestos.vue?vue&type=script&lang=js"
import style0 from "./Asistentesxpuestos.vue?vue&type=style&index=0&id=5642b0e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642b0e5",
  null
  
)

export default component.exports